import tooltip from 'common/utils/tooltip';

const SIMULATED_MODAL_ID = '#simulatedModal';

class TooltipMobileController {
  constructor() {
    this.tooltip = tooltip;
  }

  $onInit() {
    this.modalId = `#${this.name}`;
    this.modal = $(this.modalId);
  }

  openModal() {
    this.modal.modal('show');
  }

  closeModal() {
    this.modal.modal('hide');
  }

  openSimulatedModal() {
    $(`#${this.idNestedModal}`).before($(SIMULATED_MODAL_ID));
    $(`#${this.idNestedModal}`).css('display', 'none');
    $(SIMULATED_MODAL_ID).css('display', 'block');
  }

  closeSimulatedModal() {
    $(SIMULATED_MODAL_ID).css('display', 'none');
    $(`#${this.idNestedModal}`).css('display', 'block');
  }
}

export default TooltipMobileController;



// WEBPACK FOOTER //
// ./client/app/components/tooltipMobile/tooltipMobile.controller.js